import React from 'react'
import PropTypes from 'prop-types'
import style from './block.mod.scss'
import { Content, Button } from '@components'

const Block = ({
  children,
  type,
  id,
  padding = 'None',
  background = 'None',
  maxWidth = 'None',
  gutters = false,
  introGutters = false,
  guttersReverse = false,
  overflow = 'Unset',
  heading,
  leadNode,
  backgroundStyle = 'Default',
  smallHeading = false,
  link,
  overflowHidden = false,
  centreChildren = false
}) => {
  const modifiers = [
    style[
      'block--padding-' +
        padding
          .trim()
          .toLowerCase()
          .replace(/ /gi, '-')
    ],
    style[
      'block--bg-' +
        background
          .trim()
          .toLowerCase()
          .replace(/ /gi, '-')
    ],
    style[`block--max-width-${maxWidth.toLowerCase().replace(/ /gi, '-')}`],
    style[`block--overflow-${overflow.toLowerCase().replace(/ /gi, '-')}`],
    backgroundStyle &&
      style[
        `block--bg-style-${backgroundStyle.toLowerCase().replace(/ /gi, '-')}`
      ]
  ]
  gutters && modifiers.push(style['block--gutters'])
  introGutters && modifiers.push(style['block--intro-gutters'])
  guttersReverse && modifiers.push(style['block--gutters-reverse'])
  overflowHidden && modifiers.push(style['block--overflow-hidden'])
  centreChildren && modifiers.push(style['block--centre-children'])

  const config = {
    className: [style.block, ...modifiers].join(' '),
    id,
    children: (
      <>
        {(heading || leadNode?.childMarkdownRemark?.html) && (
          <div className={style.block__intro}>
            {heading &&
              (!smallHeading ? (
                <h2 className={style.block__heading} children={heading} />
              ) : (
                <h3 className={style.block__heading} children={heading} />
              ))}
            {leadNode?.childMarkdownRemark?.html && (
              <Content contentNode={leadNode} />
            )}
          </div>
        )}
        {children}
        {(link?.link?.path || link?.url) && (
          <div className={style.block__button}>
            <Button centered to={link?.link?.path || link?.url}>
              {link.displayText}
            </Button>
          </div>
        )}
      </>
    )
  }

  switch (type) {
    case 'section':
      return <section {...config} />
    default:
      return <div {...config} />
  }
}

Block.propTypes = {
  children: PropTypes.node.isRequired
}

export default Block
